import workflowConstants from '../constants';

const styles = theme => ({
  accordionTitleHead: {
    padding: `4px ${workflowConstants.lg.panelContainerPaddingHorizontal}`,
    borderBottom: '1px solid #EBEEF3',
    display: 'flex',
    '& > div': {
      alignItems: 'center',
      margin: '0 !important',
    },
    '& svg': {
      fontSize: '26px',
    },
    '& p': {
      fontSize: '16px',
      color: theme.palette.primary.adgmBlack,
      fontWeight: 600,
    },
    '& img': {
      marginRight: '10px',
    },
  },
  accordionDetails: {
    padding: `8px ${workflowConstants.lg.panelContainerPaddingHorizontal}`,
    borderBottom: '2px solid #EBEEF3',
  },
  docsFlexContainer: {
    transition: 'all 1s',
    width: '100%',
  },
  fileFlex: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '12px 0px',
    '& p': {
      fontSize: '16px',
    },
    '& img': {
      marginRight: '10px',
      width: '32px',
      height: '32px',
    },
    '& button': {
      marginLeft: 'auto',
      textTransform: 'none',
      color: theme.palette.primary.darkGrey,
    },
  },

  [`@media (max-width: ${workflowConstants.md.size}px)`]: {
    accordionTitleHead: {
      padding: `4px 4px 4px ${workflowConstants.md.panelContainerPaddingHorizontal}`,
      '& p': {
        fontSize: '14px',
      },
      '& img': {
        width: '24px',
        height: '24px',
      },
    },
    accordionDetails: {
      padding: `8px 0px 8px ${workflowConstants.md.panelContainerPaddingHorizontal}`,
    },
    fileFlex: {
      padding: '6px 0px',
      '& p': {
        fontSize: '12px',
      },
      '& img': {
        width: '24px',
        height: '24px',
      },
      '& button': {
        marginLeft: 'auto',
        textTransform: 'none',
        fontSize: '12px',
      },
    },
  },
});

export default styles;
